import { render, staticRenderFns } from "./ProductPopup.vue?vue&type=template&id=79bbb861&scoped=true&"
import script from "./ProductPopup.vue?vue&type=script&lang=js&"
export * from "./ProductPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProductPopup.vue?vue&type=style&index=0&id=79bbb861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bbb861",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79bbb861')) {
      api.createRecord('79bbb861', component.options)
    } else {
      api.reload('79bbb861', component.options)
    }
    module.hot.accept("./ProductPopup.vue?vue&type=template&id=79bbb861&scoped=true&", function () {
      api.rerender('79bbb861', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ProductPopup.vue"
export default component.exports